export default "__VITE_ASSET__CD62aA_9__"